var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.groups?.length)?_c('v-data-table',{attrs:{"items":_vm.groups,"headers":_vm.headers,"dense":"","mobile-breakpoint":"0"},scopedSlots:_vm._u([{key:"item.total",fn:function({ item }){return [_c('span',[_vm._v(_vm._s(_vm._f("currency")(item.total)))])]}}],null,false,4031140330)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }